  console.log('loaded reveal description');

document.addEventListener('DOMContentLoaded', function() {
  const descriptionWrapper = document.querySelector('.collection-description');
  const readMoreButton = document.getElementById('collectionDescription');

  // 1. Check if both elements exist on the page
  if (descriptionWrapper && readMoreButton) {

    // 2. Function to toggle the expanded state
    function toggleDescription() {
      descriptionWrapper.classList.toggle('is-expanded');
      
      // Update the button text based on the state
      if (descriptionWrapper.classList.contains('is-expanded')) {
        readMoreButton.textContent = 'Read Less';
      } else {
        readMoreButton.textContent = '...Read More';
      }
    }
    
    // 3. Add the click listener to the button
    readMoreButton.addEventListener('click', function(e) {
      e.preventDefault(); // Stop any default link behavior
      toggleDescription();
    });

    // 4. Initial check: Only show the button if the description is actually too long
    //    We check the scroll height against the initial max-height defined in CSS.
    //    This prevents an unnecessary button from appearing on short descriptions.
    //    NOTE: You must define a max-height in your CSS for this check to work.
    if (descriptionWrapper.scrollHeight > descriptionWrapper.clientHeight) {
      readMoreButton.style.display = 'block'; // Show the button
      // Set initial button text
      readMoreButton.textContent = '...Read More';
    } else {
      // Hide the button if the content fits in the default height
      readMoreButton.style.display = 'none'; 
    }
  }
});